// Where the scroll-stage globe looks for each chapter of the home page story.
// Pure data, so it is easy to test and the scene stays free of page logic.

export type GlobeView = {
  /** Radians to face. `undefined` means: keep spinning at `speed`. */
  yaw?: number
  /** Zoom on top of the layout radius. */
  scale: number
  /** 0..1: how bright the arcs and travelling dots are. */
  glow: number
  /** Auto-spin speed multiplier (1 = the hero's drift). Ignored when `yaw` is set. */
  speed: number
  /** Second of the 24 s incident story to show (see `story()` in the scene). */
  storyAt: number
  /** true: the story plays on from `storyAt`; false: it is held on that second. */
  play: boolean
}

/** Rotation that brings a longitude to the front of the globe. */
export const faceLon = (deg: number) => -(deg * Math.PI) / 180

export const CHAPTER_VIEWS: readonly GlobeView[] = [
  // The globe always turns (owner, 2026-10-11); chapters change speed, zoom and story.
  // 1. Browser checks: a failed checkout seen in all three regions, turning slowly.
  { scale: 1, glow: 0.35, speed: 0.8, storyAt: 15.5, play: false },
  // 2. Consensus: the globe turns while EU fails first and the other regions follow.
  { scale: 1, glow: 1, speed: 1.4, storyAt: 10, play: true },
  // 3. 30-second checks: the same globe, turning faster, pulses running.
  { scale: 1.04, glow: 0.7, speed: 2.2, storyAt: 0, play: true },
  // 4. Alerts: a little closer, turning slowly.
  { scale: 1.1, glow: 0.4, speed: 0.8, storyAt: 15.5, play: false },
]

export function viewForChapter(index: number): GlobeView {
  const i = Math.min(Math.max(Math.trunc(index) || 0, 0), CHAPTER_VIEWS.length - 1)
  return CHAPTER_VIEWS[i]
}
